import type { KeyboardEvent, KeyboardEventHandler } from 'react';

const ACTIONS_CODES = ['Space', 'Enter', 'NumpadEnter'];

export const getHandleActionKeyDown = (callback?: KeyboardEventHandler) => {
  return (event: KeyboardEvent) => {
    if (ACTIONS_CODES.includes(event.code)) {
      event.preventDefault();
      callback?.(event);
    }
  };
};
